var map = {
	"./1 FRONTE.jpg": 3019,
	"./1_FRONTE.jpg": 2331,
	"./2_FRONTE.jpg": 5132,
	"./3_FRONTE.jpg": 2858,
	"./4_FRONTE.jpg": 6817,
	"./5_FRONTE.jpg": 5253,
	"./6_FRONTE.jpg": 8940,
	"./7_FRONTE.jpg": 4266,
	"./8_FRONTE.jpg": 9338,
	"./Logo21LugliosenzaOnlus.png": 2609,
	"./beatrice.mp4": 1495,
	"./beatrice.png": 7972,
	"./biblioteca_vivente_logo_h.svg": 8426,
	"./copertine/2023/copertina_1.png": 4507,
	"./copertine/2023/copertina_2.png": 2444,
	"./copertine/2023/copertina_3.png": 548,
	"./copertine/2023/copertina_4.png": 7460,
	"./copertine/2023/copertina_5.png": 5927,
	"./copertine/2023/copertina_6.png": 7574,
	"./copertine/2023/copertina_7.png": 6394,
	"./copertine/2023/copertina_8.png": 1415,
	"./eriselda.jpg": 3875,
	"./eriselda.mp4": 4461,
	"./fatou.mp4": 1328,
	"./fatou.png": 1753,
	"./fatoumata.mp4": 6978,
	"./fatoumata.png": 2885,
	"./hanane.jpg": 4900,
	"./hanane.mp4": 1663,
	"./kwanza.mp4": 871,
	"./kwanza.png": 6860,
	"./leidy.mp4": 1565,
	"./leidy.png": 4597,
	"./logo.png": 6949,
	"./logo.svg": 9574,
	"./logo_unar.svg": 2008,
	"./michele.jpg": 5415,
	"./michele.mp4": 627,
	"./nezgiba.jpg": 3240,
	"./nezgiba.mp4": 9488,
	"./nezgiba_b.jpg": 6664,
	"./placeholder-img-3.jpg": 8763,
	"./placeholder-logo-5.png": 282,
	"./ruth.jpg": 1001,
	"./ruth.mp4": 4594,
	"./sajjad.jpg": 9914,
	"./sajjad.mp4": 2467,
	"./samira.jpg": 5718,
	"./samira.mp4": 9253,
	"./sheillea.mp4": 3814,
	"./sheillea.png": 5226,
	"./shila.jpg": 2973,
	"./shila.mp4": 8228,
	"./svetlana.jpg": 5484,
	"./svetlana.mp4": 2496,
	"./zeneb.mp4": 1011,
	"./zeneb.png": 3250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;